import React, { useState } from 'react';
import RandomCard from '../randomCard';
import { summariseHtml } from '../../utils';
import Masonry from 'react-masonry-css';
import { useHistory } from 'react-router';
import { useApp } from '../../contexts/useApp';
import { kataType as KataType } from '../../constants';
import useConfirmModal from '../../hooks/useConfirmModal';
import Loading from '../loading';
import { deleteKataById } from '../../services/apiService';

const defaultTitle = 'Delete Kata';
const defaultContent = 'Are you sure you want to delete this Kata?';

const Section = ({ cards, myKata, setMCards }) => {
  const { openConfirmModal, ConfirmModal } = useConfirmModal(defaultTitle, defaultContent);
  const history = useHistory();
  const { state } = useApp();
  const gotoKata = (id, title) => {
    const slug = title.replace(/\s+/g, '-').toLowerCase();
    history.push(`/kata/${slug}/${id}`);
  };
  const [isDeleting, setIsDeleting] = useState(false);
  const deleteKata = id => {
    openConfirmModal(async () => {
      setIsDeleting(true);
      try {
        const kata = deleteKataById(id);
        setMCards(cards => cards.filter(card => card.id !== id));
      } catch (error) {
        console.log(error);
      } finally {
        setIsDeleting(false);
      }
    });
  };

  return (
    <>
      {isDeleting && <Loading />}
      <ConfirmModal title={defaultTitle} content={defaultContent} />
      <Masonry
        breakpointCols={3}
        className="my-masonry-grid"
        columnClassName="my-masonry-grid_column"
      >
        {cards.map((card, index) => (
          <RandomCard
            key={index}
            title={card.title}
            updated={card.updated}
            content={summariseHtml(card.content, card.contentCount)}
            randomType={card.randomType}
            randomNum={card.randomNum}
            className="masonry-card"
            onClick={() => gotoKata(card.id, card.title)}
            onDelete={e => {
              e.stopPropagation();
              deleteKata(card.id);
            }}
            onEdit={e => {
              e.stopPropagation();
              history.push(`/kata/${card.id}/edit`);
            }}
            isLogged={Boolean(state.profile.username) && myKata === KataType.MY}
          />
        ))}
      </Masonry>
    </>
  );
};

export default Section;
